module.exports = "img/36.781d30.webp";